import React from 'react';
import _Avatar from '@material-ui/core/Avatar';
import { createIcon } from '../common';



export class Avatar extends React.Component {
   
    constructor(props) {
        super(props);
    }


    render() {
        let p = {...this.props};
        delete p.icon;
        let Icon = createIcon(this.props.icon,"MuiAvatar-fallback");
        return (
            <_Avatar {...p}>
                {Icon||p.children}
            </_Avatar>
        )
    }
}

    
Avatar.defaultProps = {
    className:''
}